export default __webpack_public_path__ + "img/fa11dc4d7643f0dd157069451f40e322.svg";